import { handleRequest } from "../utilities/requestHandler";

/**
 * Fetch the Ask AI (CHIP) analytics dashboard from the first-party pipeline.
 * Mirrors the existing /chip/admin service calls' shape: a plain query object is
 * passed to handleRequest, which maps it to GET params. Note handleRequest never
 * throws — callers must inspect the returned payload's `status`/`data`.
 *
 * @param {object} query range/filters/pagination — see the server's
 *   getChipAnalyticsDashboard (chipAnalytics.controller.js) for accepted keys
 * @returns {Promise<object>} `{ status, data, message }` envelope (or the error
 *   payload handleRequest swallows into the same shape)
 */
export const getChipAnalyticsDashboard = (query) =>
	handleRequest("get", "/chip-analytics/dashboard", query);

/**
 * Fetch the exact rows and breakdowns behind one Ask AI KPI card.
 * @param {object} query dashboard filters + { kpi, detailPage, detailPageSize,
 *   detailSearch } — see the server's getChipKpiDetail for accepted keys
 * @returns {Promise<object>} `{ status, data: { title, columns, rows, summaries,
 *   total, clamped } }` envelope (handleRequest never throws)
 */
export const getChipKpiDetail = (query) =>
	handleRequest("get", "/chip-analytics/kpi-detail", query);
